<template>
    <div id="content">

        <b-modal :busy="saving" id="modal-vehicle" title="Create User Vehicle" @ok="onSave" v-if="!loading"
                 :disabled="saving">
            <b-form @submit.prevent.stop="onSave">
                <b-form-group label="Manufacturer">
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0 form-control form-control-sm" :options="manufacturers"
                                   @change="loadModels"></b-form-select>
                </b-form-group>

                <b-form-group label="Model">
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0 form-control form-control-sm" :options="models" v-model="form.model"></b-form-select>
                </b-form-group>

                <b-form-group label="Year">
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0 form-control form-control-sm" :options="years" v-model="form.year"></b-form-select>
                </b-form-group>

                <b-form-group label="Plate">
                    <b-form-input id="surname" type="text" required placeholder="Plate" v-model="form.plate"></b-form-input>
                </b-form-group>

                <b-form-group label="VIN Number">
                    <b-form-input id="surname" type="text" required placeholder="VIN" v-model="form.vin"></b-form-input>
                </b-form-group>

                <b-form-group label="Access">
                    <b-form-checkbox
                            id="canTrip"
                            v-model="form.canTrip"
                            name="canTrip"
                            :value="true"
                            :unchecked-value="null">
                       Can Trip
                    </b-form-checkbox>
                    <b-form-checkbox
                            id="canCargo"
                            v-model="form.canCargo"
                            name="canCargo"
                            :value="true"
                            :unchecked-value="null">
                       Can Cargo
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group v-if="form.canCargo" label="Cargo Capacity">
                    <b-form-input id="cargoSize" type="number" required placeholder="Cargo Capacity" v-model="form.cargoSize"></b-form-input>
                </b-form-group>
            </b-form>
        </b-modal>

        <div id="search" class="bg-light rounded d-block">
            <b-form @submit.prevent.stop="onSearch" @reset="onSearchReset" inline>
                <b-input class="mb-2 mr-sm-2 mb-sm-0 form-control-range" placeholder="Plate"
                         v-model="search.plate"></b-input>
                <b-input class="mb-2 mr-sm-2 mb-sm-0 form-control-range" placeholder="VIN"
                         v-model="search.vin"></b-input>
                <div class="ml-auto">
                    <b-button type="reset" class="mb-2 mr-sm-2 mb-sm-0">Reset</b-button>
                    <b-button v-b-modal.modal-vehicle type="button" variant="primary" class="mb-2 mr-sm-2 mb-sm-0" :disabled="loading">Add New</b-button>
                    <b-button type="submit" variant="primary" class="mb-2 mb-sm-0" :disabled="loading">Search</b-button>
                </div>
            </b-form>
        </div>

        <loader v-if="loading"></loader>
        <div id="list" v-else>
            <div v-if="data.data.length > 0">
                <b-table small striped hover :items="data.data" :fields="fields">
                    <template v-slot:cell(model)="data">
                        {{data.item.model.manufacturer.name}} {{data.value.name}}
                    </template>

                    <template v-slot:cell(users)="data">
                        <div v-if="data.value.length > 0">
                            <router-link class="badge badge-pill badge-primary mr-1" v-for="user in data.value" :key="user.id" :to="{ name: 'userDetail', params: { id: user.id }}">{{user.name}} {{user.surname}}</router-link>
                        </div>
                        <span v-else class="badge badge-light">None</span>
                    </template>

                    <template v-slot:cell(canTrip)="{item}" >
                        <div class="text-center">
                            <b-icon scale="5" v-if="item.canTrip" icon="dot" variant="success"></b-icon>
                            <b-icon scale="5" v-else icon="dot" variant="secondary"></b-icon>
                        </div>
                    </template>

                    <template v-slot:cell(canCargo)="{item}" >
                        <div class="text-center">
                            <b-icon scale="5" v-if="item.canCargo" icon="dot" variant="success"></b-icon>
                            <b-icon scale="5" v-else icon="dot" variant="secondary"></b-icon>
                        </div>
                    </template>

                    <template v-slot:cell(createdAt)="data">
                        {{ data.value | moment("MMMM Do YYYY") }}
                    </template>
                </b-table>
                <div class="ml-auto">
                    <b-pagination
                            @change="setPage"
                            :disabled="loading"
                            align="right"
                            v-model="data.page"
                            :total-rows="data.total"
                            :per-page="search.perPage"
                    ></b-pagination>
                </div>
            </div>

            <div class="card text-center" v-else>
                <div class="card-body">
                    <h5 class="card-title">Search Result</h5>
                    <p class="card-text">No Data</p>
                    <b-button @click="onSearchReset" variant="primary">Reset</b-button>
                </div>
                <div class="card-footer text-muted">
                    {{JSON.stringify(search)}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import ContentLoader from '../../../components/ContentLoader';
  import GetVehicles from '../../../store/actions/getVehicles';
  import CreateVehicle from '../../../store/actions/createVehicle';
  import ShowError from '../../../helpers/showError';
  import GetVehicleManufacturers from "../../../store/actions/getVehicleMenufacturers";
  import GetVehicleManufacturerModels from "../../../store/actions/getVehicleManufacturerModels";

  export default {
    name: 'Vehicles',
    components: {
      loader: ContentLoader
    },
    async created() {
      this.years = Array.apply(null, new Array(15)).map((i, idx) => {
        return ({text: new Date().getFullYear() - idx, value: new Date().getFullYear() - idx});
      });
      const result = await GetVehicleManufacturers();
      this.manufacturers = result.map(item => ({text: item.name, value: item.id}));
      this.onSearch();
    },
    data() {
      return {
        form: {
          model: undefined,
          year: undefined,
          plate: undefined,
          vin: undefined,
          canCargo: null,
          canTrip: null,
          cargoSize: null,
        },
        data: {
          data: []
        },
        models: [],
        manufacturers: [],
        years: [],
        saving: false,
        loading: true,
        search: {
          perPage: 20,
          page: 1,
          plate: undefined,
          vin: undefined,
        },
        fields: ['model', 'year', 'plate', 'users', 'canTrip', 'canCargo', 'createdAt']
      }
    },
    methods: {
      async onSave(){
        try {
          this.saving = true;
          this.data = await CreateVehicle(this.form);
          this.onSearch();
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.saving = false;
        }
      },
      async loadModels(id) {
        this.saving = true;
        const result = await GetVehicleManufacturerModels(id);
        this.models = result[0].models.map(item => ({text: item.name, value: item.id}));
        this.saving = false;
      },
      setPage(page){
        this.search.page = page;
        this.onSearch();
      },
      async onSearch() {
        try {
          this.loading = true;
          this.data = await GetVehicles(this.search);
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.loading = false;
        }
      },
      onSearchReset() {
        this.search = {
          perPage: 20,
          page: 0,
          plate: undefined,
          vin: undefined,
        };
        this.onSearch();
      }
    }
  }
</script>


<style scoped>
    #search {
        margin: 10px 0;
        padding: 10px;
    }
</style>
